import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { languageProviderReducer } from '../language-provider/language-provider.reducers';
import { renderControllerReducer } from '../render-controller/render-controller.reducers';
import browserHistory from '../history/history';
import { reducer as form } from 'redux-form';
import { wishListReducer } from '../wishlist/wishlist.reducers';
import { groupListReducer } from '../grouplist/grouplist.reducers';
import { usersReducer } from '../users/users.reducers';
import { currentUserReducer } from '../current-user/current-user.reducers';
import { chatReducer } from '../chat/chat.reducers';
import { bankReducer } from '../bank/bank.reducers';

const router = connectRouter(browserHistory);

export default combineReducers({
  router,
  languageProviderReducer,
  renderControllerReducer,
  form,
  wishListReducer,
  groupListReducer,
  usersReducer,
  currentUserReducer,
  chatReducer,
  bankReducer,
});
